<kodit-dropdown
  *ngIf="jedinicaMereCtrl"
  [options]="options"
  [ctrlPlaceholder]="ctrlPlaceholder"
  [formCtrlId]="formCtrlId"
  [formCtrl]="jedinicaMereCtrl"
  (optionChanged)="handleOnItemChange($event)"
></kodit-dropdown>
